import {Component, Output, EventEmitter, Input, OnInit, ViewChild, ElementRef, Renderer2} from '@angular/core';
import {BackgroundBtnModel} from "../../models/background-btn-model";
import {StocksToolbarHelper} from "../../models/stocks-toolbar-helper";
import {ColumnSettingsBase} from "../../../slick-grid/models/column-settings-base";
import {ISlickGridColumn} from "../../../slick-grid/interfaces/slick-grid-column";
import {BufferChangeHistory} from "../../../buffer-graph/models/buffer-change-history/buffer-change-history";
import {TranslateService} from "@ngx-translate/core";
import {SlickGridComponent} from "../../../slick-grid/slick-grid.component";
import {MainHelper} from "../../models/main-helper";
import {ColumnsGenerator} from "../../../slick-grid/models/columns-generator";

@Component({
    selector: 'example-grouping',
    templateUrl: './example-grouping.component.html',
    })
export class ExampleGroupingComponent implements OnInit{

    constructor(
        public readonly translateService: TranslateService,
        public readonly renderer: Renderer2,
        public readonly elementRef: ElementRef
    ){
        this.helper = new MainHelper();
        this.selectionModel = new Slick.CellSelectionModel<any, Slick.Range[]>();
        this.groupItemMetadataProvider = new Slick.Data.GroupItemMetadataProvider<any>();
        this.dataView = new Slick.Data.DataView<BufferChangeHistory>({groupItemMetadataProvider: this.groupItemMetadataProvider});
        this.options = {syncColumnCellResize: true, multiColumnSort: true, editable: false, enableAsyncPostRender: true};
    }

    @Input()
    public columnSettings?: ColumnSettingsBase[];

    public dataView: Slick.Data.DataView<any>;

    public columns: ISlickGridColumn<any>[];

    public options: Slick.GridOptions<any>;

    public selectionModel: Slick.CellSelectionModel<any, Slick.Range[]>;
    public groupItemMetadataProvider: Slick.Data.GroupItemMetadataProvider<any>;
    public tbh: StocksToolbarHelper<any>;
    public helper: MainHelper;

    @ViewChild('grid')
    protected gridRef: SlickGridComponent;

    async ngOnInit(){
        this.tbh = new StocksToolbarHelper<any>(this.translateService, this.columnSettings, this.elementRef, this.renderer, '');


            let generator = new ColumnsGenerator(this.translateService, this.renderer, this.elementRef);
            await generator.columnsGenerate(this.columns, this.columnSettings, true, true);
    }

    ngAfterViewChecked(): void{

        if (this.tbh){
            this.tbh.ngAfterViewChecked();
        }

    }

    public setFilter = (val: boolean): void => {
        if (!val){
            return;
        }

        this.dataView.setFilter(o => this.gridRef.filterHelper.filter(o));
        this.helper.wait(() => {
            this.tbh.init(this.dataView, this.columns, this.gridRef)
            this.gridRef.initGrouping(new Slick.Data.GroupItemMetadataProvider<any>());
            this.gridRef.setDefaultTotalsFormatter();
        }, 100)

    }


}




// WEBPACK FOOTER //
// ./src/app/shared/components/example-grouping.component/example-grouping.component.ts